import React, { useEffect, useState } from "react";
import Modal from "components/common/Modal";
import { useDispatch } from "react-redux";
import { submitDraftForApproval } from "store/approvals/approvalsActions";
import { SWTypes } from "interfaces/sw/SWInterfaces";

interface IUpdateRcModal {
  staleList: string | undefined;
  close: any;
  type: SWTypes;
  guid: string;
}

const UpdateRcModal: React.FC<IUpdateRcModal> = (props) => {
  const dispatch = useDispatch();

  return (
    <Modal
      header="Old versions of Reusable Content found in Standard Work"
      controls={
        <>
          <button
            className="primary-button"
            onClick={() => {

              dispatch(
                submitDraftForApproval({
                  swGuid: props.guid,
                  swType: props.type,
                  staleReusableContentAction: "Update"
                })
              )
              props.close();
            }}
          >
            Update to Latest Version
          </button>
          <button
            className="primary-button"
            onClick={() => {
              dispatch(
                submitDraftForApproval({
                  swGuid: props.guid,
                  swType: props.type,
                  staleReusableContentAction: "Delink"
                })
              )

              props.close();
            }}
          >
            Delink Reusable Content
          </button>
          <button
            className="secondary-button"
            onClick={() => {
              props.close();
            }}
          >
            Cancel
          </button>
        </>
      }
      isOpen={true}
    >
      <p>
        This Standard Work uses Reusable Content that has been updated since
        this Standard Work was created.
      </p>
      <p>
        Please select an action to perform with this Reusable Content in the
        new Draft.
      </p>
      <p>
        You can update this Standard Work to use the latest version of the
        Reusable Content, or you can delink the Reusable Content.
      </p>
      {props.staleList !== undefined &&
        <React.Fragment>
          <p>There's a list of RCs which are not updated to the last version:</p>
          {props.staleList.split(",").map((e) => {
            return <React.Fragment key={e}>
              <span>{e}</span>
            </React.Fragment>
          })}
        </React.Fragment>
      }
    </Modal>
  );
}

export default UpdateRcModal;